import React from 'react';
import logo from '../../assets/svg/LOGO1.svg'
import {Link} from 'react-router-dom'
import { useSelector } from 'react-redux';
import {NavLink} from 'react-router-dom'
import { useLocation } from "react-router-dom";



export default function Header2() {
   const produitsDeCart = useSelector(state => state.PrduitsDeCart.produitsCard)

   const location = useLocation();

   const { pathname } = location;
  return (
        <div className='Menu'>
            <div className='logo'>
                {/* <p>logo</p> */}
                <img src={logo} alt="logo" />
            </div>
            <ul className='Autre'>
                <li className={pathname === "/" && "aactive"}> 
                    <Link to='/'>
                      Accueil <i className="fas fa-home"></i>
                    </Link>
                </li>
                <li className={pathname === "/produits" && "aactive"}>
                    <Link to='/produits' >
                        A-Propos <i className="fas fa-shopping-bag"></i>
                    </Link>
                </li>
                <li className={pathname === "/contacts" && "aactive"}>
                    <Link to='/contacts'>
                        Contact <i className="fas fa-phone"></i>
                    </Link>
                </li>
                    
                <li className= {pathname === "/cart" && "aactive"}>
                    <Link to='/cart' className='CartN'>
                        Panier 
                        <i className="fas fa-shopping-cart"></i>
                        <span className='CartNumb'>{produitsDeCart.length}</span>
                    </Link>   
                </li>
            </ul>
        </div>
    );
}
